import axios from "axios";

export default {
  strict: true,
  namespaced: true,
  state: {
    locations: [],
    location: {},
  },
  getters: {
    locations: (state) => state.locations,
    location: (state) => state.location,
  },
  mutations: {
    setLocation(state, payload) {
      state.location = payload;
      if (payload !== null) localStorage.setItem("location/businessLocationId", payload.businessLocationId);
      else localStorage.removeItem("location/businessLocationId");
    },
    setLocations(state, payload) {
      state.locations = payload;
    },
  },
  actions: {
    init: async ({ commit, state, rootState }) => {
      const currentOrg = rootState.organization.organization;

      if (currentOrg && currentOrg.type === "business") {
        await axios
          .get(`/businesses/${currentOrg.id}/locations/all`)
          .then((res) => {
            commit("setLocations", res.data);
            if (res.data.length === 1) commit("setLocation", res.data[0]);
          })
          .catch(() => {
            // todo: handle
          });

        var storedLocationId = localStorage.getItem("location/businessLocationId");

        if (storedLocationId) {
          var storedLocation = state.locations.find((element) => element.businessLocationId === storedLocationId) || null;
          commit("setLocation", storedLocation);
        } else {
          commit("setLocation", null);
        }
      }
    },
    updateLocation: (context, payload) => context.commit("setLocation", payload),
    updateLocations: (context, payload) => context.commit("setLocations", payload),
  },
};
